import { HttpStatusCodes } from '@naverpay/es-http-status-codes';
import Phase from '../config/env.mjs';
import { AuthInfoErrorCode, AuthInfoFailCode } from '../response/auth.mjs';
import { DEFAULT_URL, getPayUrl } from './common.mjs';
export function getAuthRedirectUrl(params) {
    const { statusCode, authCode, currentUrl } = params;
    // status code가 400 이하라면 무시
    if (statusCode < HttpStatusCodes.BAD_REQUEST) {
        return undefined;
    }
    // 500 에러 처리 (param error, internal server error, 페이회원 미정의, 페이회원 api error)
    if (statusCode === HttpStatusCodes.INTERNAL_SERVER_ERROR && authCode === AuthInfoErrorCode) {
        return (params === null || params === void 0 ? void 0 : params.errorUrl) || DEFAULT_URL.ERROR;
    }
    const { pc, mobile } = getPayUrl((params === null || params === void 0 ? void 0 : params.phase) || Phase.real);
    const { mobileUrl = mobile, pcUrl = pc } = params;
    /**
     * @description 관련 에러
     * NoNidIdNo 페이회원 미가입
     * NoApiResult 페이회원 미가입 (조회결과 없음)
     * Leave 페이 탈퇴
     * NotAgree 페이 약관 미동의
     * Dormancy 휴면
     * TransactionStop 거래정지
     */
    switch (authCode) {
        case AuthInfoFailCode.NotNaverMember:
            return `https://nid.naver.com/nidlogin.login?url=${encodeURIComponent(currentUrl)}`;
        case AuthInfoFailCode.NoNidIdNo:
        case AuthInfoFailCode.NoApiResult:
        case AuthInfoFailCode.Leave:
        case AuthInfoFailCode.NotAgree:
            return (params === null || params === void 0 ? void 0 : params.isMobile)
                ? `${mobileUrl}/mobile/agree?url=${encodeURIComponent(currentUrl)}`
                : `${pcUrl}/agree?url=${encodeURIComponent(currentUrl)}&payAgreeCurl=cancelURL`;
        case AuthInfoFailCode.Dormancy:
            // 페이회원상태오류 (구 페이홈)
            return (params === null || params === void 0 ? void 0 : params.isMobile) ? `${mobileUrl}/mobile/payhome` : `${pcUrl}?site_preference=NORMAL`;
        case AuthInfoFailCode.TransactionStop:
            return (params === null || params === void 0 ? void 0 : params.stopUrl) || DEFAULT_URL.STOP;
        default:
            return (params === null || params === void 0 ? void 0 : params.errorUrl) || DEFAULT_URL.ERROR;
    }
}
